import { z } from 'zod';

export enum InteractionTypeEnum {
  CallCenterInteraction = 'call-center-interaction',
  FbmsInteraction = 'fbms-interaction',
  MedicalInsight = 'medical-insight',
  DocumentedInterest = 'documented-interest',
}

export const InteractionTypesMap: Record<InteractionTypeEnum, string> = {
  [InteractionTypeEnum.CallCenterInteraction]: 'Call Center Interaction',
  [InteractionTypeEnum.FbmsInteraction]: 'MSL Interaction',
  [InteractionTypeEnum.MedicalInsight]: 'Medical Insight',
  [InteractionTypeEnum.DocumentedInterest]: 'Documented Interest',
};

export const InteractionTypeModel = z.enum(InteractionTypeEnum);
export type InteractionType = z.infer<typeof InteractionTypeModel>;

export enum InteractionSubTypeEnum {
  Introduction = 'introduction',
  Other = 'other',
  ScientificExchange = 'scientific-exchange',

  GeneralInquiry = 'general-inquiry',
  GlobalComplaint = 'global-complaint',
  MIR = 'mir',
  Settlement = 'settlement',
};
export const InteractionSubTypeModel = z.enum(InteractionSubTypeEnum);
export type InteractionSubType = z.infer<typeof InteractionSubTypeModel>;

export enum CallCenterSource {
  Chat = 'chat',
  Email = 'email',
  Fax = 'fax',
  iConnect = 'iConnect',
  Legend = 'legend',
  Mail = 'mail',
  Mobile = 'mobile',
  Phone = 'phone',
  Relypsa = 'relypsa',
  USWeb = 'US Web',
  Veeva = 'Veeva',
  WalkIn = 'walk-in',
  Web = 'web',
}